export default __webpack_public_path__ + "book_details-publisher.3f7b4cd4.png";